import { Button, Box, Typography, FormLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HipShipGreen from "../../../assests/logo/hipShipGreen.png";
import { forgotPassword } from "../../../config/api";
import { StyledInput } from "../../ui/StyledInput";
import { useModal } from "../../../hooks/useModal";
import { StyledButton } from "../../ui/StyledButton";

interface FormData {
  email: string;
}

const Login = () => {
  const [formData, setFormData] = useState<FormData>({
    email: "",
  });
  const [isError, setIsError] = useState({ email: "" });

  const { onOpen } = useModal();

  const [canSubmit, setCanSubmit] = useState(false);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setFormData({ ...formData, [name]: value });
  };

  const ifValidEmail = (email: string): boolean => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  useEffect(() => {
    if (ifValidEmail(formData.email)) {
      setCanSubmit(true);
    } else {
      setCanSubmit(false);
    }
  }, [formData]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsError({ email: "" });

    forgotPassword({
      email: formData.email,
    })
      .then((data) => {
        onOpen("otp", { email: formData.email });
      })
      .catch((error) => {
        setIsError({ email: error?.response?.data?.message });
        console.log("forgot: ", error);
      });
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        backgroundColor: "#f5f7fa",
      }}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#fff",
          gap: "20px",
          borderRadius: "10px",
          minWidth: "400px",
          boxShadow: "1px 2px 10px 0px rgba(0, 0, 0, 0.2)",
          padding: "30px 0",
        }}
      >
        <div>
          <img width={"160px"} src={HipShipGreen} alt="" draggable={false} />
        </div>
        <div>
          <Typography
            sx={{
              marginTop: "10px",
            }}
            fontSize={12}
          >
            Enter your email to receive OTP for password resetsdfsfdfsdsdf.
          </Typography>
        </div>
        <form onSubmit={handleSubmit}>
          <Box>
            <FormLabel>
              <Typography fontSize={12}>Email</Typography>
            </FormLabel>
            <StyledInput
              sx={{
                borderRadius: "10px",
                minWidth: "300px",
              }}
              margin="normal"
              id="email"
              name="email"
              autoComplete="email"
              autoFocus
              value={formData.email}
              onChange={handleInputChange}
              error={Boolean(isError.email)}
              focused={Boolean(isError.email)}
              helperText={isError.email && isError.email}
              fullWidth
            />
          </Box>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <StyledButton
              type="submit"
              disabled={!canSubmit}
              variant="contained"
            >
              Send OTP
            </StyledButton>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Link to="/login">
              <Button
                style={{
                  textTransform: "initial",
                  marginTop: "16px",
                  color: "indigo[500]",
                }}
              >
                Remember the password? Login
              </Button>
            </Link>
          </div>
        </form>
      </Box>
    </div>
  );
};

export default Login;
